<template>
  <div class="test-view teacher-test-View-cp3">
    <div v-if="isOnline">
      <div class="test-page-section" ref="testView">
        <div class="test-btn-quection">

          <div class="slide-btn-group cust-slide">
            <v-row>
              <v-col cols="1" sm="1" class="pad-zero-top-bottom">
                <div
                  v-if="
                    $refs && $refs.carousel && $refs.carousel.canAdvanceBackward
                  "
                  class="center-arrow1"
                >
                  <v-icon
                    @click.prevent="gotoDirection(true, 'backward')"
                    class="info-alert"
                    >mdi-chevron-double-left</v-icon
                  >
                  <v-icon
                    @click.prevent="gotoDirection(false, 'backward')"
                    class="info-alert"
                    >mdi-chevron-left</v-icon
                  >
                </div>
              </v-col>
              <v-col cols="10" sm="10" class="pad-zero-top-bottom">
                <carousel
                  ref="carousel"
                  :scrollPerPage="scrollPerPage"
                  :paginationEnabled="false"
                  :mouseDrag="false"
                  :perPageCustom="perPageCustom"
                  :navigateTo="navigateTo"
                >
                  <slide
                    v-for="(type, idx) in subjectQuestionTypeList"
                    :key="idx"
					v-if="type.showSQT"
                  >
                    <v-btn
                      class="btn-default carousel-btn"
                      :class="{
                        ' active ': idx == selectedSQTIndex,
                        'disabled-field': disableSecondaryAction,
                      }"
                      depressed
                      width="95%"
                      :disabled="isEditing || disableSecondaryAction"
                      :title="type.name"
                      @click="changeSubjectQuestionType(type, idx, 'JUMP')"
                    >
                      <span class="carousel-typename">{{
                        type.shortName
                      }}</span>
                      <v-tooltip bottom dark content-class="question-tooltip">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            class="info-alert"
                            v-on="on"
                            @mouseover="getLegendsData(idx)"
                            >mdi-alert-circle</v-icon
                          >
                        </template>
                        <LegendsOnHover :legendsCount="legendsData" :isPreview="isPreview"/>
                      </v-tooltip>
                    </v-btn>
                  </slide>
                </carousel>
              </v-col>
              <v-col cols="1" sm="1" class="pad-zero-top-bottom">
                <div
                  v-if="
                    $refs && $refs.carousel && $refs.carousel.canAdvanceForward
                  "
                  class="center-arrow2"
                >
                  <v-icon
                    @click.prevent="gotoDirection(false, 'forward')"
                    class="info-alert"
                    >mdi-chevron-right</v-icon
                  >
                  <v-icon
                    @click.prevent="gotoDirection(true, 'forward')"
                    class="info-alert"
                    >mdi-chevron-double-right</v-icon
                  >
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- accordian -->
          <v-expansion-panels
            class="show-mobile-panel"
            :disabled="disableSecondaryAction"
            v-model="expansionPanelStatus"
          >
            <v-expansion-panel>
<v-expansion-panel-header
                  >Question Pallet</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <div class="number-contet">
                    <LegendsPreview
                      v-if="questionData"
                      :questionStatus="questionStatus"
                      :questions="questionData.questions"
                      :isPreview="isPreview"
                      :isCustom="isTestCustom"
                    />
                    <div class="hr-div"></div>
                    <QuestionPallet
                      v-if="questionData"
                      @jumpToQuestion="jumpToQuestion"
                      :isEditing="isEditing"
                      :isPreview="isPreview"
                      :isPastTest="isPastTest"
                      :isCustom="isTestCustom"
                      :questionData="questionData"
                    />
                  </div>
				  <div class="Attributes-Questions-block">	
					  <div class="Attributes-Questions">
						  Cumulative Attributes of Questions:
						  </div>
						  <div class="Attributes-time-block">
							  <div>
								  <span>	Avg. Time:</span>{{avgTime}} 
							  </div>
						  <div>
						<span>Level:</span>{{currentQuestion.difficulty_level}} 
					</div>
				</div>	
        
			</div>	
			          <div class="PieChart-cp3-block">
            <div class="PieChart-cp3">	 
                  <PieChart
                  :seriesData="series1"
                  :height="pieChartHeight"
                  :chartOptions="chartOptions1"
                  />
            </div>
        </div>
                </v-expansion-panel-content>

            </v-expansion-panel>
          </v-expansion-panels>
          <v-card class="mx-auto normal-card live-test-hg preview-teacher-test" ref="testBlock">
            <pinch-zoom
              class="pinch-zoom"
              disableZoomControl="disable"
              :wheel="false"
            >
              <div class="tst-quection-block" ref="questionBox">
                <div v-if="questionData && questionTypes">
                  <div class="privew-test-bk">
                  <div class="repeat-que-btn">
                    <div class="chapter-name-row print-name" v-if="isPreview">
                      <div class="chapter-label" >
                        Chapter Name -
                      </div>
                      <div class="chapter-drop" >
                        {{ currentQuestion.chapterName }}
                      </div>
                      <div
					  v-if="currentQuestion.institute_id === null"
                        class="chapter-label"
                      >
                        Topic Name -
                      </div>
                      <div
                        class="chapter-drop"
						v-if="currentQuestion.institute_id === null"
                      >
                        {{ currentQuestion.topicName }}
                      </div>
                      <div
					  v-if="currentQuestion.institute_id === null"
                        class="chapter-label"
                      >
                        Level -
                      </div>
                      <div
					  v-if="currentQuestion.institute_id === null"
                        class="chapter-drop"
                      >
                        {{ currentQuestion.difficultyName }}
                      </div>
                      <div class="save-and-next-btn-outer">
                      <div class="save-and-next-btn teachprev" v-for="bq in bucketQuestions" :key="bq.id">
                          <v-btn
                            color="primary"
                            @click="onAlternateButtonClick(bq)"
                            class="cust-btn right-align"
                            :class='{"active":bq.btnClicked}'
                            >
                            Alternate Q. {{bq.suggestions}}
                          </v-btn>
					            </div>
                      </div>
                      </div>
                      <div class="repeat-btn">
                        <!-- <div class="save-and-next-btn" v-for="bq in bucketQuestions" :key="bq.id">
                          <v-btn
                            color="primary"
                            @click="onAlternateButtonClick(bq)"
                            class="cust-btn right-align"
                            :class='{"active":bq.btnClicked}'
                            >
                            Alternate Q. {{bq.suggestions}}
                          </v-btn>
					              </div> -->
           </div>
                    </div>
                    <div v-bind:resize="setHeight()"  class="que-scrollable-area prevtestteach06">
                    <Comprehension
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.COMPREHENSION ||
                          currentQuestion.question_type == questionTypes.TC
                      "
                    />
                    <SingleAnsQuePrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.SINGLE_CORRECT ||
						   currentQuestion.question_type ==
                          questionTypes.SINGLE_CORRECT_SEC2 ||
                          currentQuestion.question_type ==
                            questionTypes.ASSERTION_REASON
                      "
                    />
                    <MultipleCorrectPrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MULTIPLE_CORRECT
                      "
                    />
                    <IntegerPrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type == questionTypes.INTEGER
                      "
                    />
                    <SubjectivePrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      :isPreview="isPreview"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.SUBJECTIVE||
                          currentQuestion.question_type ==
                          questionTypes.SUBJECTIVEINTEGER
                      "
                    />
                    <MatrixMatchPrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH
                      "
                    />

                    <MatrixMatchOptionPrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH_OPTION
                      "
                    />
                    </div>
                  </div>
                </div>
              </div>
            </pinch-zoom>
          </v-card>
          <div class="btm-indicator-cp3">
              <div class="block-indicator">
                <div class="cp3590btm-label">Batchwise Response</div>
                <div class="btm-indicator correct"></div>
                <div class="btm-label">Correct</div>
              </div>
              <div class="block-indicator">
                <div class="btm-indicator incorrect"></div>
                <div class="btm-label">Incorrect</div>
              </div>
              <div class="block-indicator">
                <div class="btm-indicator unanswered"></div>
                <div class="btm-label">Unattempted</div>
              </div>
              
          </div>
          <div class="bar-chart-row">
          <div class="bar-chart-block" v-for="(chart,index) in BarChartData" :key="index">
            <div class="btm-apexchart-cp3">
              <div id="chart" class="snchart performance-chart">
                <BarChart :seriesData="chart.series" :chartOptions="chart.chartOptions" />
              </div>
            </div>
            <div  class="indicate-50">
                <v-tooltip bottom content-class="cust-new-tooltip-top open-top">
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                    depressed
                      :class="{
                      'text-transform-none': true,
                      'btn-center': true,
                      'btn-default': true,
                    }"
                    
                    >{{chart.chartOptions.label.substring(0,20) + '...'}}</span
                  >
                </template>
                <span>{{chart.chartOptions.label}} </span>
              </v-tooltip>

              </div>
          </div>
      </div>
          <!-- <div class="btm-indicator-cp3">
              <div class="block-indicator">
                <div class="btm-indicator correct"></div>
                <div class="btm-label">Correct</div>
              </div>
              <div class="block-indicator">
                <div class="btm-indicator incorrect"></div>
                <div class="btm-label">Incorrect</div>
              </div>
              <div class="block-indicator">
                <div class="btm-indicator unanswered"></div>
                <div class="btm-label">Unattempted</div>
              </div>
              
          </div> -->
		 
        </div>
        <div class="test-counter-block show-desktop-panel">
          <div class="test-time-count teacherpreviewtest">
			   <div class="save-and-next-btn">
              <v-btn
                v-if="
                  isPreview &&
                     currentQuestion.institute_id === null
                "
            	    :disabled="isEditing || isAnswerBtnClicked"
                color="primary"
                @click="openReportErrorDialog()"
                class="cust-btn cp3590close-preview"
              >
                Report Error
              </v-btn>

            </div>
          
          </div>
          <div class="inner-block">
            <v-expansion-panels v-model="panel">
              <v-expansion-panel class="number-contet" expand v-model="panel">
                <!-- <v-expansion-panel-header> -->
                  <div class="quection-palette-block">Question Palette</div>
                <!-- </v-expansion-panel-header> -->
                <v-expansion-panel-content>
                  <div class="number-contet">
                    <LegendsPreview
                      v-if="questionData"
                      :questionStatus="questionStatus"
                      :questions="questionData.questions"
                      :isPreview="isPreview"
                      :isCustom="isTestCustom"
                    />
                    <div class="hr-div"></div>
                    <QuestionPallet
                      v-if="questionData"
                      @jumpToQuestion="jumpToQuestion"
                      :isEditing="isEditing"
                      :isPreview="isPreview"
                      :isPastTest="isPastTest"
                      :isCustom="isTestCustom"
                      :questionData="questionData"
                    />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
			<div class="Attributes-Questions-block">	
				<div class="Attributes-Questions">
					Cumulative Attributes of Question:
				</div>
				<div class="Attributes-time-block">
					<div>
					<span>	Avg. Time:</span>{{avgTime}} 
					</div>
					<div>
						<span>Level:</span>{{currentQuestion.difficulty_level}} 
					</div>
				</div>	
        
			</div>
        
          </div>
          <div class="PieChart-cp3-block">
            <div class="PieChart-cp3">	 
                  <PieChart
                  :seriesData="series1"
                  :height="pieChartHeight"
                  :chartOptions="chartOptions1"
                  />
            </div>
        </div>
        </div>
      </div>
      <div class="save-and-next-btn">
              
			</div>
      <div class="test-bottom cp3590test-bottom">
        <div class="bottom-logo">
          <!-- <img src="/img/logo-footer.c1b83f14.png" class="master-logo-btm" /> -->
        </div>
        <div class="test-btn-block-answering cp310aug-setw100">
          <div class="cp3590test-btn-block-answering"><v-btn
              color="primary"
                      @click="updateQuestionStatus(QUESTION_ACTIONS.SUBMIT)"
                      class="cust-btn right-align"
              >
                      Next
              </v-btn>
            </div>
          <v-btn
            color="default"
            class="cust-btn finish-test cp3590close-preview"
            @click="finishTest('manual')"
            :disabled="
              disableSecondaryAction"
            >{{ isPreview ? "Close Preview" : "Finish Test" }}</v-btn
          >
        </div>
      </div>
    </div>
    <div class="no-internet" v-else>
      <h4>
        Please check your internet connection. Reload the page or wait on this
        screen till internet is back.
      </h4>
    </div>
    <AlertBox
      :width="modalWidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import isMobile from "is-mobile";
import moment from "moment";
import momentDuration from "moment-duration-format";
momentDuration(moment);
import BarChart from "@/components/Charts/BarChart.vue";
import PieChart from "@/components/Charts/PieChart.vue";

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

import QuestionPallet from "@/components/PreviewTest/QuestionPallet.vue";
import MiniQuestionPallet from "@/components/PreviewTest/MiniQuestionPallet.vue";
import LegendsPreview from "@/components/PreviewTest/LegendsPreview.vue";
import LegendsOnHover from "@/components/PreviewTest/LegendsOnHover.vue";
import Comprehension from "@/components/PreviewTest/Comprehension.vue";
import SingleAnsQuePrivew from "@/components/PreviewTest/SingleAnsQuePrivew.vue";
import MultipleCorrectPrivew from "@/components/PreviewTest/MultipleCorrectPrivew.vue";
import IntegerPrivew from "@/components/PreviewTest/IntegerPrivew.vue";
import SubjectivePrivew from "@/components/PreviewTest/SubjectivePrivew.vue";
import AssertionReasonPrivew from "@/components/PreviewTest/AssertionReasonPrivew.vue";
import MatrixMatchOptionPrivew from "@/components/PreviewTest/MatrixMatchOptionPrivew.vue";
import MatrixMatchPrivew from "@/components/PreviewTest/MatrixMatchPrivew.vue";

// importing components for edit mode
import SingleAnsQue from "@/components/QuestionType/SingleAnsQue.vue";
import MultipleCorrect from "@/components/QuestionType/MultipleCorrect.vue";
import Subjective from "@/components/QuestionType/Subjective.vue";
import Integer from "@/components/QuestionType/Integer.vue";
import MatrixMatchOption from "@/components/QuestionType/MatrixMatchOption.vue";
import MatrixMatch from "@/components/QuestionType/MatrixMatch.vue";
import Comprehensions from "@/components/QuestionType/Comprehensions.vue";
import TC from "@/components/QuestionType/TC.vue";

// importing axios to cancel heartbeat request if it is pending state till the next heartbeat is called
import axios from "axios";
import constants from "@/utils/constants.js";

export default {
  name: "PreviewTestTeacher",
  components: {
    QuestionPallet,
    MiniQuestionPallet,
    LegendsPreview,
    LegendsOnHover,
    Comprehension,
    SingleAnsQuePrivew,
    MultipleCorrectPrivew,
    IntegerPrivew,
    SubjectivePrivew,
    AssertionReasonPrivew,
    MatrixMatchOptionPrivew,
    MatrixMatchPrivew,
    SingleAnsQue,
    MultipleCorrect,
    Subjective,
    Integer,
    MatrixMatchOption,
    MatrixMatch,
    Comprehensions,
    TC,
    dummyOptionsPQR: [],
    dummyOptions: [],
    dummyOptionsABC: [],
    Carousel,
    Slide,
    BarChart,
	        PieChart

	  },
  async mounted() {
	  if (this.user.role_id === this.roleIds.TR) {
      this.getTeacherSubjectTree();
    }
    this.questionTypes = this.QUE_TYPES;
    this.questionStatus = this.QUESTION_STATUS;
    this.questionStatusColor = this.QUESTION_STATUS_COLOR;
    this.setIsPastTest(false);
    await this.setCustomData();
    this.reverseQuestionsType();
    this.requestGetTestDetails();
    this.renderMath();
    let screensize = document.querySelector('#app').offsetHeight; 
    this.pieChartHeight = screensize / 4.6;
	  this.barChartHeight = screensize / 5.5;
    localStorage.removeItem('alternateQ')
	
this.setHeight()
  },
  data() {
    return {
      isPastTest: false,
      navigateTo:0,
      is_preview: true,
      modalWidth: null,
      instructionsTooltip: null,
      cComponent: "components/coordinator/Questionadd",
      alertBoxData: {},
      persistent: false,
      status: false,
      testDetails: null,
      questionTypes: this.QUE_TYPES,
      questionStatus: this.QUESTION_STATUS,
      questionStatusColor: this.QUESTION_STATUS_COLOR,
      questionTypesReversed: {},
      questionsList: {},
      questionData: {},
      panel: 0,
      questions: [],
	  bucketQuestions:[],
      currentQuestion: {},
      legendsData: {
        answered: 0,
        reviewLater: 0,
        answeredReviewLater: 0,
        notVisited: 0,
        notAnswered: 0,
		easy:0,
		moderate:0,
		tough:0
      },
      instructions: "",
      isEditing: false,
      currentQuestionToBeEdited: {},
      showNextButton: false,
      isTestCustom: true,
      isPreview: false,
      scrollPerPage: false,
      direction: "",
      endAction: "",
      duration: null,
      timeRemainingString: "",
      timeRemainingInterval: null,
      heartBeatInterval: null,
      isOnline: true,
      timeObj: null,
      chapters: [],
      perPageCustom: [
        [1900, 6],
        [1650, 5],
        [1550, 4],
        [1400, 3],
        [1300, 3],
        [1280, 3],
        [1024, 2],
        [768, 2],
        [480, 1],
        [340, 1],
      ],
      pageStatus: [],
      pageInactive: false,
      inactiveStartTime: null,
      nextQuestionIndex: 0,
      showNextQuestion: true,
      isSQTChanged: false,
      isAnswerBtnClicked: false,
      scrollQtypeValue: null,
      isBlurred: false,
      hideTimer: false,
      finishTestError: null,
      responseTimeOut: null,
      cancelBeatSource: null,
      showTimer: false,
      expansionPanelStatus: [],
      remainingTimeInterval: null,
      testAutoFinished: false,
      topics: [],
      selectedTopic: {},
      difficulty: constants.DIFFICULTY_LEVELS,
      selectedDifficultyLevel: {},
      searchAnotherQuestions: {},
      isSearchAnotherQ: false,
      isUploadAndReplace: false,
      isEditable: false,
	  teacherSubjectId:[],
	  pieChartHeight: 180,
	   series: [],
       series1: [],
            chartOptions1: {
                legend: {
                    show: false
                },
                stroke: {
                    show: true,
                    curve: "smooth",
                    lineCap: "round",
                    colors: "#000000",
                    width: 0.5
                },
                fill: {
					  colors: ["#96ea96", "#ff7373", "#dcdcdc", "#869fe2"],

                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        dataLabels: {
                            offset: -20,
                            minAngleToShowLabel: 10
                        }
                    }
                },
                dataLabels: {
                    style: {
                        fontSize: "13px",
                        fontFamily: "Helvetica, Arial, sans-serif",
                        fontWeight: 500,
                        colors: ["#000"]
                    }
                }
            },
	BarChartData:[],		
	avgTime:0,
  barChartHeight : 0
    };
  },

  destroyed() {
    this.clearAllIntervals();
    // window.onbeforeunload = null;
    document.removeEventListener(
      "visibilitychange",
      this.checkVisiblity,
      false
    );
    document.removeEventListener("contextmenu", null, false);
    document.onkeydown = null;
    window.removeEventListener("popstate", null);
    window.onpopstate = null;
    window.onblur = null;
    window.onfocus = null;
    this.scrollToTop();
    // this.setIsTestStarted(false);
  },
  computed: {
    ...mapState("userStore", ["user", "pendingTestList"]),

    ...mapGetters("testStore", {
      questionsListStore: "questionsList",
      filteredQuestionsList: "filteredQuestionsList",
      testData: "testData",
      subjectQuestionTypeList: "subjectQuestionTypeList",
      selectedSQTIndex: "selectedSQTIndex",
      disableSecondaryAction: "disableSecondaryAction",
    }),
    isLastQuestion() {
      if (
        this.subjectQuestionTypeList &&
        this.selectedSQTIndex == this.subjectQuestionTypeList.length - 1 &&
        this.questionData.currentQuestionIndex == this.questions.length - 1
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    instructionsTooltip(val) {
      this.renderMath();
    },
    // status(val){
    // 	if(!val){
    // 		this.requestGetTestDetails();
    // 	}
    // },
    // selectedSQTIndex(newVal) {
    // this.getQuestionData();
    // this.renderMath();
    // },
    subjectQuestionTypeList(newVal) {
      this.endAction = this.QUESTION_ACTIONS.TEST_STARTED;
      this.showNextQuestion = true;
      this.getQuestionData();
      this.renderMath();
    },
  },
  methods: {
    ...mapActions({
      setTestData: "testStore/setTestData",
      remainingTime: "testStore/remainingTime",
      setSubjectQuestionTypeList: "testStore/setSubjectQuestionTypeList",
      setFilteredQuestionsList: "testStore/setFilteredQuestionsList",
      setSelectedSQTIndex: "testStore/setSelectedSQTIndex",
      setSelectedQuestionIndex: "testStore/setSelectedQuestionIndex",
      getTestPreviewDetails: "testStore/getTestPreviewDetails",
      getLiveTestDetails: "testStore/getLiveTestDetails",
      setQuestions: "questionStore/setQuestions",
    //   createTest: "testStore/createTest",
    //   uploadAndReplaceQuestion: "testStore/uploadAndReplaceQuestion",
      updateProgressInDB: "testStore/updateProgressInDB",
      updateHeartBeat: "testStore/updateHeartBeat",
      setIsTestStarted: "testStore/setIsTestStarted",
      setPendingTestList: "userStore/setPendingTestList",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      setDisableSecondaryAction: "testStore/setDisableSecondaryAction",
    //   searchAnotherQuestion: "testStore/searchAnotherQuestion",
      setPendingTestList: "userStore/setPendingTestList",
      getTeacherSubject: "userStore/getTeacherSubject",
    //   replaceTestQuestion: "testStore/replaceTestQuestion",
      getBucketQuestion: "testStore/getBucketQuestion",
      getTestQuestionData: "testStore/getTestQuestionData",


    }),
    ...mapMutations("testStore", ["setIsPastTest"]),
    // onClose(data) {
    //   this.status = data.status;
    //    if(data.reload){
    // 	  this.requestGetTestDetails();
    //   }
    // },
	getQuestionDetails(){
		const reqData = {
        	test_id: this.testDetails.id,
        	question_id: this.currentQuestion.id
    	}
      
      this.series1=[];
      this.series=[];
      this.BarChartData = [];
		this.getTestQuestionData(reqData)
			.then(response => {
				this.processBatchWiseData(response.batchWiseQuestionData,response.cumalativeQuestionData)
			})
			.catch(err => {
				console.log(err);
				this.$toasted.error("Error finding batchwise details")
			})
	},
	 processBatchWiseData(data1,data2) {
    //   let series = [
    //     {
    //       name: "Correct",
    //       data: [],
    //     },
    //     {
    //       name: "Incorrect",
    //       data: [],
    //     },
    //     {
    //       name: "Unanswered",
    //       data: [],
    //     },
    //   ];
      data1.map((c) => {
      let Label = [];

		   let series = [
        {
          name: "Correct",
          data: [],
        },
        {
          name: "Incorrect",
          data: [],
        },
        {
          name: "Unanswered",
          data: [],
        },
      ];
			let chartOptions={
				chart: {
					type: "bar",
					height: this.barChartHeight ,
					// width: "100%",
					toolbar: {
						show: false,
					},
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: "50",
						barHeight: "50",
					},
				},
				stroke: {
					width: 0,
					colors: ["#fff"],
				},
				grid: {
					show: false,
				},
				states: {
					hover: {
						filter: {
							type: "none",
						},
					},
				},
				xaxis: {
          axisBorder: {
              show: true,
              color: '#000000',
              offsetX: 0,
              offsetY: 0,
              height: 1
            },
					categories: [],
					labels: {
						show: false,
						style: {
							fontSize: "13px",
							fontWeight: 400,
						},
					},
				},
				yaxis: {
					min: 0,
					max: 100,
					tickAmount:5,
          labels: {
           formatter: function(val) {
            return val + '%'
          }},
           axisBorder: {
              show: true,
              color: '#000000',
              offsetX: 0,
              offsetY: 0
                
            },
				},
				fill: {
					colors: ["#96ea96", "#ff7373", "#dcdcdc", "#869fe2"],
				},
				legend: {
					show: false,
				},
				dataLabels: {
					enabled: false,
					textAnchor: "end",
					style: {
						colors: ["#000"],
					},
				},
				tooltip:{
					enabled:true,
					onDatasetHover: {
						highlightDataSeries: false,
					},
					marker: {
						show: false,
					},
				}
			};
		  Label.push(c.center_name);
		  Label.push(c.name);
      
        let correctAttempt = (c.correct_attempt/c.total*100).toFixed(1);
        let incorrectAttempt = (c.in_correct_attempt/c.total*100).toFixed(1);
        let unAttempt = (c.unattempt/c.total*100).toFixed(1);

        series[0].data.push(correctAttempt);
        series[1].data.push(incorrectAttempt);
        series[2].data.push(unAttempt);

      this.series = series;
      this.series1=[];
      chartOptions.label = Label.join(",");
      chartOptions.xaxis.categories[0] = '';
    //   chartOptions.tooltip = tooltip;
	  const obj = {
		  series : series,
		  chartOptions : chartOptions
	  } 
	  this.BarChartData.push(obj)
		// console.log(this.BarChartData);
	  });

      
	  	  data2.map((c) => {
				let Label = []
		  Label.push(c.center_name)
		  Label.push(c.name)
        this.series1.push(c.correct_attempt);
         this.series1.push(c.in_correct_attempt);
         this.series1.push(c.unattempt);
		 this.avgTime = Math.ceil(c.avg_time_spent) +' sec'
      });
     
    //   if (chapters.length > 2)
    //     this.chartOptions.chart.height = chapters.length * 60 + "px";
    //   else this.chartOptions.chart.height = "150px";
    },
 		getQuestionBucket() {
            let reqData = {
                test_detail_id: this.currentQuestion.test_detail_id,
                target_exam: this.testDetails.target,
                required_question_details: true,
				        question_type:this.currentQuestion.question_type,
				        difficulty_level:this.currentQuestion.difficulty_level
            };
            this.getBucketQuestion(reqData)
                .then((response) => {
                    this.separateBucketQuestions(response.list);
                    this.$root.showLoader = false;
                })
                .catch((err) => {
                  this.$root.showLoader = false;
                });
        },
         async separateBucketQuestions(question) {
            let questions = question;
            // questions.sort(this.compare);
            let fql = {}; // filteredQuestionsList
            let subjectQuestionTypeList = {}; // for showing subject - section list
            this.$root.showLoader = true;

            for (let i = 0; i < questions.length; i++) {
                let questionTypeId = 0;
                let questionTypeName = "";
                let q = null; // question
                let currentQuestionType = null; // current question in particular subject
                let subjectName = null; // current subject
                let subjectId = null; // current subject
                let subjectQuestionTypeObj = {};
                let questionId = 0;

                q = questions[i];
                questionId = q.id;
                questionTypeId = q.questiontype
                    ? q.questiontype.id
                    : q.question_type;
                questionTypeName = q.questiontype ? q.questiontype.value : "";
            }
            await this.generateBucketQuestionsList(question);
        },
        //     setCurrentQuestionData(typeIndex, questionIndex) {
        //       this.setSelectedSQTIndex(typeIndex);
        //     },
        async generateBucketQuestionsList(question) {
            let ql = question;
            let currentQuestion = {};
            let questionsList = [];

            for (let i = 0; i < ql.length; i++) {
                const q = ql[i]; // current question in loop
             if(q.is_bucket_question === true){
                let questionTypeId = q.question_type;
                questionTypeId =
                    questionTypeId == this.questionTypes.COMPREHENSION ||
                    questionTypeId == this.questionTypes.TC
                        ? q.subtype
                        : q.question_type;
                let currentQuestion = {};
                currentQuestion = this.generateBucketQuestionObject(
                    questionTypeId,
                    q
                );
                currentQuestion.subtype = q.subtype;
                if (
                    q.question_type == this.questionTypes.COMPREHENSION ||
                    q.question_type == this.questionTypes.TC
                ) {
                    currentQuestion.passage = q.passage;
                }
                currentQuestion = this.getBucketQuestionCommonKeys(
                    currentQuestion,
                    q,
                    i
                );
                questionsList.push(currentQuestion);
            }
        }
            this.bucketQuestions = questionsList;
        },
        getBucketQuestionCommonKeys(currentQuestion, q, index) {
            currentQuestion.id = q.id;
            currentQuestion.questionNo =
                q.index || this.currentQuestion.questionNo;
            currentQuestion.suggestions = index + 1;
            currentQuestion.is_bucket_question = q.is_bucket_question;
            currentQuestion.question_text = q.question_text;
            currentQuestion.question_type = q.question_type;
            currentQuestion.questionType = { id: q.question_type };
            currentQuestion.parent_id = q.parent_id;
            currentQuestion.section_id = q.section_id;
            currentQuestion.test_detail_id = q.test_detail_id;
            currentQuestion.correct_marks = q.marks;
            currentQuestion.negative_marks = q.negative_marks;
            currentQuestion.partial_marking = q.partial_marking;
            currentQuestion.solution = q.solution;
            currentQuestion.hints = q.hints;
            currentQuestion.userSelectedAnswer = q.user_selected_answer;
            currentQuestion.status = this.questionStatus.INITIAL; // "status" along with "isAnswered" will be used for loading legends & pallet info
            currentQuestion.isAnswered = false; // to know if the current question is answered.
            currentQuestion.disabled = false; // disabled in case of preview test
            currentQuestion.isPreview = this.isPreview; // disabled in case of preview test
            currentQuestion.institute_id = q.institute_id;
			currentQuestion.btnClicked = false;
            if (this.isPreview) {
                currentQuestion.status = this.questionStatus.ANSWER_SELECTED_SAVED; // "status" along with "isAnswered" will be used for loading legends & pallet info
                currentQuestion.isAnswered = this.isPreview; // to know if the current question is answered.
                currentQuestion.disabled =this.isPreview; // disabled in case of preview test
            }
            if (q.user_selected_answer && !this.isPreview) {
                let answer = JSON.parse(q.user_selected_answer);
                currentQuestion.isAnswered = answer.answer ? true : false;
                currentQuestion.status = answer.status;
            }

            return currentQuestion;
        },
        checkIfBucketAnswered(type, q) {
            let option = null;
            if (q.user_selected_answer && !this.isPreview) {
                let answer = JSON.parse(q.user_selected_answer);
                q.status = answer.status;
                let options = q.options.map((o) => {
                    return { ...o, ...{ correct_answer: false } };
                });
                if (answer.answer) {
                    let switchType = 1;
                    if (
                        this.questionTypes.ASSERTION_REASON == type ||
                        this.questionTypes.SINGLE_CORRECT == type ||
                        this.questionTypes.SINGLE_CORRECT_SEC2 == type ||
                        this.questionTypes.COMPREHENSION_2Q_SA == type ||
                        this.questionTypes.COMPREHENSION_2Q_MM == type ||
                        this.questionTypes.COMPREHENSION_3Q_SA == type ||
                        this.questionTypes.TC_2Q_SA == type ||
                        this.questionTypes.TC_3Q_SA == type
                    ) {
                        switchType = 1;
                    } else {
                        switchType = 2;
                    }
                    switch (switchType) {
                        case 1:
                            option = options.find(
                                (o) => o.id == answer.answer.option_id
                            );
                            if (option) option.correct_answer = true;
                            break;

                        case 2:
                            answer.answer.option_id.map((a) => {
                                option = options.find((o) => o.id == a);
                                if (option) option.correct_answer = true;
                            });
                            break;
                    }
                }
                return options;
            } else return q.options;
        },
        generateBucketQuestionObject(typeId, q) {
            let type = "";
            type = this.getBucketQuestionType(typeId);
            let currentQuestion = {};
            currentQuestion.chapterId = q.data_type_id;
            currentQuestion.chapterName = q.datatype ? q.datatype.title : "";
            currentQuestion.datatype = q.datatype;
            currentQuestion.answer_type = q.answer_type;
            currentQuestion.difficulty = q.difficulty;
            currentQuestion.difficulty_level = q.difficulty_level || null;
            currentQuestion.time = q.time;
            currentQuestion.topic_id = q.topic_id;
            currentQuestion.topicName = q.topic ? q.topic.title : "";
            currentQuestion.topic = q.topic;

            currentQuestion = this.getBucketQuestionCommonKeys(
                currentQuestion,
                q
            );
            switch (type) {
                case 1:
                    currentQuestion.options = this.checkIfBucketAnswered(typeId, q);
                    break;
                case 2:
                    if (this.isPreview) {
                        currentQuestion.correct_answer = q.correct_answer;
                    } else if (q.user_selected_answer) {
                        let answer = JSON.parse(q.user_selected_answer);
                        currentQuestion.correct_answer = parseInt(
                            answer.answer
                        );
                    } else {
                        currentQuestion.correct_answer = null;
                    }
                    break;
                case 3:
                    let matrixOptions = this.separateOptions(q, 1);
                    currentQuestion.options_abc = matrixOptions.options_abc;
                    currentQuestion.options_pqr = matrixOptions.options_pqr;
                    break;
                case 4:
                    let options = this.separateOptions(q, 2);
                    currentQuestion.options_abc = options.options_abc;
                    currentQuestion.options_pqr = options.options_pqr;
                    currentQuestion.options = options.op;
                    break;
                case 6:
                    if (this.isPreview) {
                        currentQuestion.correct_answer = q.correct_answer;
                    } else if (q.user_selected_answer) {
                        let answer = JSON.parse(q.user_selected_answer);
                        currentQuestion.correct_answer = answer.answer;
                    } else {
                        currentQuestion.correct_answer = "";
                    }
                    let subjectiveAnswers = this.getSubjectiveAnswers(
                        currentQuestion.correct_answer,
                        q
                    );
                    currentQuestion.startValue = subjectiveAnswers.startValue;
                    currentQuestion.endValue = subjectiveAnswers.endValue;
                    break;
            }
            return currentQuestion;
        },
        getBucketQuestionType(id) {
            if (
                id == this.questionTypes.ASSERTION_REASON ||
                id == this.questionTypes.MULTIPLE_CORRECT ||
                id == this.questionTypes.SINGLE_CORRECT ||
                id == this.questionTypes.SINGLE_CORRECT_SEC2 ||
                id == this.questionTypes.COMPREHENSION_2Q_SA ||
                id == this.questionTypes.COMPREHENSION_2Q_MM ||
                id == this.questionTypes.COMPREHENSION_2Q_MA ||
                id == this.questionTypes.COMPREHENSION_3Q_SA ||
                id == this.questionTypes.COMPREHENSION_3Q_MA ||
                id == this.questionTypes.TC_2Q_SA ||
                id == this.questionTypes.TC_3Q_SA
            ) {
                return 1;
            } else if (id == this.questionTypes.INTEGER) {
                return 2;
            } else if (id == this.questionTypes.MATRIX_MATCH) {
                return 3;
            } else if (id == this.questionTypes.MATRIX_MATCH_OPTION) {
                return 4;
            } else if (id == this.questionTypes.COMPREHENSION) {
                return 5;
            } else if (id == this.questionTypes.SUBJECTIVE || id == this.questionTypes.SUBJECTIVEINTEGER) {
                return 6;
            }
        },

   openReportErrorDialog() {
      this.alertBoxData = {
        question: this.currentQuestion,
        errorDescription: "",
      };
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/student/Tests/PastTests/ReportError";
      this.$forceUpdate();
    },
    getChapters(subjectId,subSubject) {
      if (subjectId) {
        this.chapters = [];
        let reqData = {
          level: 3,
          parent: subjectId,
          sub_subject:subSubject
        };
        this.$root.showLoader = true;

        this.getDataTreeWithLevel(reqData)
          .then((response) => {
            this.$root.showLoader = false;
            this.chapters = response.map((x) => {
              let c = {};
              c.text = x.title;
              c.value = { chapter_id: x.id, title: x.title };
              return c;
            });
          })
          .catch((err) => {
            this.$root.showLoader = false;	
          });
      }
    },
    getTopics(chapterId) {
      if (chapterId || this.slectedChapter.chapter_id) {
        let reqData = {
          level: 4,
          parent: chapterId || this.slectedChapter.chapter_id,
        };
        this.$root.showLoader = true;
        this.getDataTreeWithLevel(reqData)
          .then((response) => {
            this.$root.showLoader = false;
            this.topics = response.map((x) => {
              let c = {};
              c.text = x.title;
              c.value = { topic_id: x.id, title: x.title };
              return c;
            });
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      }
    },
    onSelectChapter(e) {
      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.chapterId = e.chapter_id;
        this.currentQuestionToBeEdited.chapterName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.chapterId = e.chapter_id;
        this.currentQuestion.chapterName = e.title;
      }
      this.getTopics(e.chapter_id);
    },
    onSelectedTopic(e) {
      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.topic_id = e.topic_id;
        this.currentQuestionToBeEdited.topicName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.topic_id = e.topic_id;
        this.currentQuestion.topicName = e.title;
      }
    },
    onselectedDifficulty(e) {
      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.difficultyId = e.id;
        this.currentQuestionToBeEdited.difficultyName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.difficultyId = e.id;
        this.currentQuestion.difficultyName = e.title;
      }
    },
    getRemainingTimeInterval() {
      this.remainingTimeInterval = setInterval(() => {
        if (!document.hidden && document.hasFocus()) {
          this.getRemainingTime(true);
        }
      }, 120 * 1000);
    },
    startTimer(timeRemaining) {
      let timeFromBackend = moment.duration(timeRemaining, "minutes");
      let updateTimeRemaining = true;
      if (this.timeObj) {
        try {
          let diffInSeconds = Math.abs(
            this.timeObj.asSeconds() - timeFromBackend.asSeconds()
          );
          if (diffInSeconds > 15) {
            updateTimeRemaining = true;
          } else {
            updateTimeRemaining = false;
          }
        } catch (error) {
          updateTimeRemaining = false;
          this.$toasted.error("Error setting timer. Please reload page.");
          location.reload();
        }
      }
      // if(!updateTimeRemaining) return;
      if (timeRemaining > 0) {
        let timeObj = null;
        if (updateTimeRemaining) {
          timeObj = moment.duration(timeRemaining, "minutes");
        } else if (!updateTimeRemaining && this.timeRemainingInterval) {
          return; // return if timer is not stopped due to pagevisibility
        } else {
          timeObj = this.timeObj;
        }
        if (this.timeRemainingInterval) {
          clearInterval(this.timeRemainingInterval);
        }
        this.timeRemainingInterval = setInterval(() => {
          if (this.isOnline) {
            timeObj.subtract(1, "seconds");
            this.timeObj = timeObj;
            let timeRemainingString = timeObj.format("hh:mm:ss");
            if (
              timeRemainingString == "00" ||
              (timeObj.hours() <= 0 &&
                timeObj.minutes() <= 0 &&
                timeObj.seconds() <= 0)
            ) {
              this.timeRemainingString = "0";
              this.finishTest("timeUp");
            } else {
              this.timeRemainingString = timeObj.format("hh:mm:ss");
            }
            this.hideTimer = false;
          }
        }, 1000);
      } else {
        this.$toasted.error("The amount of time given for this test is over.");
        this.setIsTestStarted(false);
        this.$router.push({ name: "schedule-tests" });
      }
    },
    startHeartBeatTimer() {
      if (this.heartBeatInterval) {
        clearInterval(this.heartBeatInterval);
      }
      this.heartBeatInterval = setInterval(() => {
        this.heartBeat();
      }, this.HEART_BEAT_TIME);
    },
    cancelPendingBeats() {
      if (this.cancelBeatSource) {
        this.cancelBeatSource.cancel();
      }
    },
    heartBeat() {
      // if (this.pageInactive) {
      //     let currentTime = moment();
      //     let duration = moment.duration(
      //         currentTime.diff(this.inactiveStartTime)
      //     );
      //     let minutes = duration.asMinutes();
      //     if (!document.hidden && minutes > 3.0) {
      //         this.getRemainingTime();
      //     }
      // }
      if (!document.hidden && this.isBlurred && document.hasFocus()) {
        this.getRemainingTime(false);
      }

      this.cancelPendingBeats();
      this.cancelBeatSource = axios.CancelToken.source();

      let postData = {
        test_institute_id: this.testDetails.test_institute_id,
        question_id: this.currentQuestion.id,
        test_detail_id: this.currentQuestion.test_detail_id,
        test_schedule_id: this.testDetails
          ? this.testDetails.test_schedule_id
          : -1,
        beat: this.cancelBeatSource,
      };
      this.updateHeartBeat(postData)
        .then((res) => {
          this.cancelBeatSource = null;
          this.isOnline = true;
        })
        .catch((err) => {
          if (
            !err.data ||
            !(
              err.data.errors[0].code == "ERR419" ||
              err.data.errors[0].code == "ERR401"
            )
          ) {
            this.isOnline = false;
          }
        });
    },
    clearAllIntervals() {
      if (this.timeRemainingInterval) {
        clearInterval(this.timeRemainingInterval);
      }
      // this is to close the interval which get remaining time every 2 minutes
      if (this.remainingTimeInterval) {
        clearInterval(this.remainingTimeInterval);
      }
      if (this.heartBeatInterval) {
        clearInterval(this.heartBeatInterval);
      }
      if (this.responseTimeOut) {
        clearInterval(this.responseTimeOut);
      }
    },
    scrollToTop() {
      let content = this.$refs.questionBox;
      if (content) content.scrollTop = 0;
      let scrollElem = document.getElementsByClassName("v-application--wrap");
      scrollElem[0].scrollIntoView();
    },
    gotoDirection(scrollPerPage, direction) {
      this.direction = direction;
      // this.scrollPerPage = scrollPerPage;
      this.$refs.carousel.currentPage = Math.round(
        this.$refs.carousel.offset / this.$refs.carousel.slideWidth
      );
      if (
        this.direction == "backward" &&
        this.$refs.carousel.currentPage == 1
      ) {
        this.$refs.carousel.handleNavigation(this.direction);
        return;
      }
      this.scrollPerPage = scrollPerPage;
      this.$refs.carousel.currentPage = this.$refs.carousel.scrollPerPage
        ? Math.round(
            this.$refs.carousel.offset /
              this.$refs.carousel.slideWidth /
              this.$refs.carousel.currentPerPage
          )
        : Math.round(
            this.$refs.carousel.offset / this.$refs.carousel.slideWidth
          );
      this.$refs.carousel.handleNavigation(this.direction);
    },
    legendsForWholeTest() {
      let legends = [];

      this.subjectQuestionTypeList.forEach((sqtl) => {
        var questions = [];
        questions = sqtl.questions;
        let legendsData = {
          answered: 0,
          reviewLater: 0,
          answeredReviewLater: 0,
          notVisited: 0,
          notAnswered: 0,
          questions: questions.length,
          name: sqtl.name,
        };
        questions.forEach((val) => {
          if (val.status == this.QUESTION_STATUS.ANSWER_SELECTED_SAVED) {
            legendsData.answered++;
          }
          if (val.status == this.QUESTION_STATUS.ANSWER_NOT_SELECTED_REVIEW) {
            legendsData.reviewLater++;
          }
          if (val.status == this.QUESTION_STATUS.ANSWER_SELECTED_REVIEW) {
            legendsData.answeredReviewLater++;
          }
          if (val.status < this.QUESTION_STATUS.VISITED) {
            legendsData.notVisited++;
          }
          if (
            (val.status == this.QUESTION_STATUS.VISITED && !val.isAnswered) ||
            val.status == this.QUESTION_STATUS.ANSWER_NOT_SELECTED_SAVED
          ) {
            legendsData.notAnswered++;
          }
        });
        legends.push(legendsData);
      });
      return legends;
    },
    gotoSummary() {
      try {
        if (!this.isPreview) {
          let testData = {
            timeRemaining: this.timeRemainingString,
            isTimeUp: this.timeRemainingString == "0" ? true : false,
            // subjectQuestionTypeList: this.subjectQuestionTypeList,
            legends: this.legendsForWholeTest(),
            testId: this.testDetails.id,
            instituteId: this.testDetails.test_institute_id,
            testScheduleId: this.testDetails.test_schedule_id,
            questionId: this.currentQuestion.id,
            testDetailId: this.currentQuestion.test_detail_id,
            timeObj: this.timeObj,
            testType: this.testDetails.test_type,
            isAutoFinished: this.testAutoFinished,
          };
          let routeInfo = {
            path: this.$route.path,
            testFinished: false,
          };
          sessionStorage.setItem("routeInfo", JSON.stringify(routeInfo));
          sessionStorage.setItem("testData", JSON.stringify(testData));
          sessionStorage.setItem("timeObj", JSON.stringify(this.timeObj));
        }
        this.$root.showLoader = false;
        this.$router.push({ name: "exam-summary" });
      } catch (e) {
        this.finishTestError = e;
        this.endAction = this.QUESTION_ACTIONS.FINISH_TEST_ERROR;
        this.saveCurrentAction("currentQuestion");
      }

      // if (this.isPreview) this.$router.back();
    },
    finishTest(status) {
          this.removeCookie();
		
		this.$router.push({name: 'past-tests-teacher'})
    //   if (!this.isPreview) {
    //     this.clearAllIntervals();
    //     this.endAction = this.QUESTION_ACTIONS.FINISH_TEST;
    //     this.showNextQuestion = false;
    //     this.testAutoFinished = false;
    //     if (status == "timeUp") {
    //       this.testAutoFinished = true;
    //     }
    //     this.saveCurrentAction("currentQuestion");
    //   } else {
    //     if (this.isEditing) {
    //       this.$toasted.error(
    //         "The changes you have made to this question have not been saved. Please click on Done to save the changes."
    //       );
    //     } else {
    //       this.removeCookie();
    //       console.log("close");
    //       this.redirectAsTypePreview();
    //     }
    //   }
    },
    removeCookie() {
      let currentTestCookieExists = this.$cookies.isKey("CATAPULT_TEST");
      if (currentTestCookieExists) {
        this.$cookies.remove("CATAPULT_TEST");
      }
    },
    redirectAsTypePreview() {
      let route = "customized-tests";
      let routeName = localStorage.getItem("routeName");
	  let previousRoute = localStorage.getItem('previousRoute')
	  
      if (routeName != "preview-test") {
        routeName = this.$route.name;
      }


      if (routeName == "result-anaylysis-preview-test") {
        route = "test-results";
      } else if(previousRoute === 'assign-tests'){
		  route = previousRoute;
	  } else {
        switch (this.testDetails.test_type) {
          case this.TEST_TYPE.COMPLIMENTARY:
            route = "complimentary-test";
            break;
          case this.TEST_TYPE.ALL_INDIA_TEST:
            route = "all-india-test-series";
            break;
          case this.TEST_TYPE.CUSTOM:
            route = "customized-tests";
            break;
        }
      }
      localStorage.removeItem("routeName");
      localStorage.removeItem("previousRoute");

      this.$router.push({ name: route });
    },
    showInstructions() {
      this.alertBoxData = {};
      this.alertBoxData.selectedTest = {
        instructions: this.instructions,
      };
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/coordinator/Tests/InstructionsPopup";
      this.$forceUpdate();
    },
    setCustomData() {
      let routeName = this.$route.name;
      if (
        routeName == "past-tests-preview" || 
        routeName == "result-anaylysis-preview-test"
      ) {
        this.isPreview = true;
      } else {
        this.setIsTestStarted(true);
        this.disableNavigation(); // user cannot go back
        this.handleKeyboardEvents();

        // give user the ability to stop reload
        // let that = this;
        // window.onbeforeunload = function(event) {
        //     that.heartBeat();
        //     event.preventDefault();
        //     return false;
        // };
      }
      if (this.isPreview && routeName == "preview-test") {
        localStorage.setItem("routeName", routeName);
      }
    },
    updateSearchAnotherQuestion(q, qDetails) {
		this.currentQuestion.id = qDetails.id;
      this.currentQuestion.question_text = qDetails.question_text;
      this.currentQuestion.solution = qDetails.solution;
      this.currentQuestion.hints = qDetails.hints;
      this.currentQuestion.topic_id = qDetails.topic_id;
      this.currentQuestion.topicName = qDetails.topic?qDetails.topic.title:"";
      this.currentQuestion.chapterId = qDetails.data_type_id;
      this.currentQuestion.chapterName =qDetails.datatype? qDetails.datatype.title:"";
      this.currentQuestion.difficultyName =
        this.difficulty.find((d) => d.id === qDetails.difficulty_level).title ||
        "";
      this.currentQuestion.difficultyId =
        this.difficulty.find((d) => d.id === qDetails.difficulty_level).id || 0;
		this.currentQuestion.difficulty_level =
        this.difficulty.find((d) => d.id === qDetails.difficulty_level).id || 0;
		this.currentQuestion.btnClicked = qDetails.btnClicked;
      let questionsToBeUpdated = null;
      let editedSubquestion = null;
      switch (this.currentQuestion.question_type) {
        case this.questionTypes.INTEGER:
          this.currentQuestion.correct_answer = qDetails.correct_answer;
          break;

        case this.questionTypes.MATRIX_MATCH:
          this.currentQuestion.options_abc = qDetails.options.filter(
            (o) => o.column == 1
          );
          this.currentQuestion.options_pqr = qDetails.options.filter(
            (o) => o.column == 2
          );
          // this.currentQuestion.options_abc = q.options_abc;
          // this.currentQuestion.options_pqr = q.options_pqr;
          break;

        case this.questionTypes.MATRIX_MATCH_OPTION:
          this.currentQuestion.options_abc = qDetails.options.filter(
            (o) => o.column == 1
          );
          this.currentQuestion.options_pqr = qDetails.options.filter(
            (o) => o.column == 2
          );
          this.currentQuestion.options = qDetails.options.filter(
            (o) => o.column == null
          );
          // this.currentQuestion.options_abc = q.options_abc;
          // this.currentQuestion.options_pqr = q.options_pqr;
          // this.currentQuestion.options = q.options;
          break;

        case this.questionTypes.COMPREHENSION:
          questionsToBeUpdated = this.questions.filter(
            (qt) => qt.parent_id == qDetails.parent_id
          );
          editedSubquestion = qDetails.questions[0];
          questionsToBeUpdated.forEach((ques) => {
            ques.passage = qDetails.question_text;
            if (ques.id == editedSubquestion.id) {
              ques.question_text = editedSubquestion.question_text;
              ques.options = editedSubquestion.options;
            }
          });
          break;

        case this.questionTypes.TC:
          questionsToBeUpdated = this.questions.filter(
            (qt) => qt.parent_id == qDetails.parent_id
          );
          editedSubquestion = qDetails.questions[0];
          questionsToBeUpdated.forEach((ques) => {
            ques.passage = qDetails.question_text;
            if (ques.id == editedSubquestion.id) {
              ques.question_text = editedSubquestion.question_text;
              ques.options = editedSubquestion.options;
            }
          });
          break;

        case this.questionTypes.SUBJECTIVE:
        case this.questionTypes.SUBJECTIVEINTEGER:
          this.currentQuestion.correct_answer = qDetails.correct_answer;
          if (qDetails.questionType.id === this.questionTypes.SUBJECTIVE || qDetails.questionType.id === this.questionTypes.SUBJECTIVEINTEGER) {
            this.currentQuestion.startValue = qDetails.startValue;
            this.currentQuestion.endValue = qDetails.endValue;
          }
          break;

        case this.questionTypes.ASSERTION_REASON:
          this.currentQuestion.options = qDetails.options;
          break;

        case this.questionTypes.MULTIPLE_CORRECT:
          this.currentQuestion.options = qDetails.options;
          break;

        case this.questionTypes.SINGLE_CORRECT:
        case this.questionTypes.SINGLE_CORRECT_SEC2:
          this.currentQuestion.options = qDetails.options;
          break;
      }
	 	this.series1 = []
		this.BarChartData = []
		this.getQuestionDetails();

      this.renderMathData();
      this.renderMathData();
    },

    getHintsForRequest(hints) {
      let hintsArr = [];
      for (let idx = 0; idx < hints.length; idx++) {
        let hint = hints[idx];
        if (this.extractContent(hint.text, true).trim() != "") {
          let h = {
            hint: hint.text,
          };
          if (hint.id) {
            h.id = hint.id;
          }
          hintsArr.push(h);
        }
      }
      return hintsArr;
    },
    showAllQuestions() {
      this.alertBoxData = {};
      this.alertBoxData.subjectQuestionTypeList = [];
      let subjectQuestionTypeList = this.subjectQuestionTypeList;
      subjectQuestionTypeList.forEach((sqt) => {
        let sqtObj = Object.assign({}, sqt);
        sqtObj.showAnswerField = false;
        this.alertBoxData.subjectQuestionTypeList.push(sqtObj);
      });
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/PreviewTest/QuestionPaper";
      this.$forceUpdate();
    },
    renderMathData() {
      this.renderMath();
    },
    getLegendsData(index) {
      this.legendsData = {
        answered: 0,
        reviewLater: 0,
        answeredReviewLater: 0,
        notVisited: 0,
        notAnswered: 0,
		easy:0,
		moderate:0,
		tough:0
      };
      let questions = [];
      if (index != null) {
        questions = this.subjectQuestionTypeList[index].questions;
      } else {
        questions = Object.values(this.filteredQuestionsList);
      }
      questions.forEach((val) => {
        if (val.status == this.questionStatus.ANSWER_SELECTED_SAVED) {
          this.legendsData.answered++;
        }
        if (val.status == this.questionStatus.ANSWER_NOT_SELECTED_REVIEW) {
          this.legendsData.reviewLater++;
        }
        if (val.status == this.questionStatus.ANSWER_SELECTED_REVIEW) {
          this.legendsData.answeredReviewLater++;
        }
        if (val.status < this.questionStatus.VISITED) {
          this.legendsData.notVisited++;
        }
        if (
          (val.status == this.questionStatus.VISITED && !val.isAnswered) ||
          val.status == this.questionStatus.ANSWER_NOT_SELECTED_SAVED
        ) {
          this.legendsData.notAnswered++;
        }
		if(val.difficulty_level === this.difficulty[0].id){
			  this.legendsData.easy ++;
		  }
		  if(val.difficulty_level === this.difficulty[1].id){
			  this.legendsData.moderate ++;
		  }
		  if(val.difficulty_level === this.difficulty[2].id){
			  this.legendsData.tough ++;
		  }

		   if(val.difficulty_level === null && val.institute_id){
			  this.legendsData.moderate ++;
		  }
      });
    },
    getQuestionData() {
      this.questionData = this.subjectQuestionTypeList[this.selectedSQTIndex];
      this.questions = this.questionData.questions;
      this.scrollQtypeValue = 1;
      this.saveCurrentAction("nextQuestion");
      this.getChapters(this.questionData.subjectId,this.questionData.questions[0].sub_subject);
    },
    async clearReponse() {
      this.expansionPanelStatus = null;
      this.showTimer = false;
      this.currentQuestion.status = this.questionStatus.VISITED;
      this.currentQuestion.isAnswered = false;
      let currentQuestionType = this.currentQuestion.question_type;
      if (
        currentQuestionType == this.questionTypes.TC ||
        currentQuestionType == this.questionTypes.COMPREHENSION
      ) {
        currentQuestionType = this.currentQuestion.subtype;
      }
      let type = await this.getQuestionType(currentQuestionType);

      if (!this.isPreview) {
        this.endAction = this.QUESTION_ACTIONS.CLEAR;
        this.saveCurrentAction("clearQuestion");
      }
      this.scrollToTop();
      switch (type) {
        case 1:
          this.currentQuestion.options = this.currentQuestion.options.map(
            (opt) => {
              opt.correct_answer = false;
              return opt;
            }
          );
          break;
        case 2:
          this.currentQuestion.correct_answer = "";
          break;
        case 3:
          this.currentQuestion.options_abc = this.currentQuestion.options_abc.map(
            (opt) => {
              opt.correct_answer = "";
              return opt;
            }
          );
          break;
        case 4:
          this.currentQuestion.options = this.currentQuestion.options.map(
            (opt) => {
              opt.correct_answer = false;
              return opt;
            }
          );
          break;
        case 5:
          let subQuestions = this.currentQuestion.questions;
          subQuestions.forEach((sq) => {
            sq.options = sq.options.map((q) => {
              q.correct_answer = false;
              return q;
            });
          });
          break;
        case 6:
          this.currentQuestion.correct_answer = "";
          this.currentQuestion.startValue = null;
          this.currentQuestion.endValue = null;
          break;
      }
      this.setDisableSecondaryAction(false);
    },
    async updateQuestionStatus(ansStatus) {
      this.bucketQuestions=[];
      this.setDisableSecondaryAction(false);
      this.isAnswerBtnClicked = true;
      this.showTimer = false;
      let currentQuestionStatus = this.currentQuestion.status;
      let isAnswered = this.currentQuestion.isAnswered;
      let newStatus = currentQuestionStatus;

      if (isAnswered) {
        if (ansStatus == this.QUESTION_ACTIONS.SUBMIT) {
          newStatus = this.questionStatus.ANSWER_SELECTED_SAVED;
          this.endAction = this.QUESTION_ACTIONS.SUBMIT;
        }
        if (ansStatus == this.QUESTION_ACTIONS.REVIEW_LATER) {
          newStatus = this.questionStatus.ANSWER_SELECTED_REVIEW;
          this.endAction = this.QUESTION_ACTIONS.ANSWER_REVIEW_LATER;
        }
      } else {
        if (ansStatus == this.QUESTION_ACTIONS.SUBMIT) {
          newStatus = this.questionStatus.ANSWER_NOT_SELECTED_SAVED;
          this.endAction = this.QUESTION_ACTIONS.NEXT;
        }
        if (ansStatus == this.QUESTION_ACTIONS.REVIEW_LATER) {
          newStatus = this.questionStatus.ANSWER_NOT_SELECTED_REVIEW;
          this.endAction = this.QUESTION_ACTIONS.REVIEW_LATER;
        }
      }

      this.currentQuestion.status = newStatus;
      this.nextQuestionIndex = this.questionData.currentQuestionIndex + 1;
      this.showNextQuestion = true;
      this.scrollQtypeValue = null;
      this.saveCurrentAction("currentQuestion");
    },

    getPostData(type) {
      return [
        {
          activity: this.QUESTION_ACTIVITY.STOP,
          entity: "",
          entity_id: 0,
        },
        {
          activity: this.QUESTION_ACTIVITY.START,
          entity: "",
          entity_id: 0,
        },
      ];
    },
    getUpdateProgressPostData(type) {
      let postData = [
        {
          activity: this.QUESTION_ACTIVITY.STOP,
          entity: "",
          entity_id: 0,
        },
        {
          activity: this.QUESTION_ACTIVITY.START,
          entity: "",
          entity_id: 0,
        },
      ];
      if (type == "currentQuestion") {
        return [postData[0]];
      } else if (type == "nextQuestion") {
        return [postData[1]];
      } else if (
        type == "firstQuestion" ||
        type == "lastQuestion" ||
        type == "clearQuestion"
      ) {
        return postData;
      }
    },
    saveCurrentAction(type) {
      // let currentQuestion = this.currentQuestion;
      if (this.isPreview) {
        // this.currentQuestion = this.questions[];
        this.nextQuestion();
      } else {
        this.updateCurrentAction(type);
      }
    },
    updateCurrentAction(questionStatus) {
      let cq = this.currentQuestion;
      let callApi = false;
      let postData = this.getUpdateProgressPostData(questionStatus);
      let p1 = postData[0];
      let p2 = null;
      let defaultActions = [
        this.QUESTION_ACTIONS.NEXT,
        this.QUESTION_ACTIONS.SUBMIT,
        this.QUESTION_ACTIONS.REVIEW_LATER,
        this.QUESTION_ACTIONS.ANSWER_REVIEW_LATER,
        this.QUESTION_ACTIONS.JUMP,
      ];
      if (defaultActions.includes(this.endAction) && cq.id) {
        if (cq) {
          callApi = true;
          p1.activity = this.QUESTION_ACTIVITY.STOP;
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.test_detail_id = cq.test_detail_id;
          p1.entity_id = cq.id;
          p1.section_id = cq.section_id;
          p1.end_action = this.endAction;
          p1.answer = {
            status: cq.status,
            answer: this.getAnswerAsPerType(cq),
          };
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.TEST_STARTED) {
        if (cq) {
          callApi = true;
          p1.activity = this.QUESTION_ACTIVITY.START;
          p1.entity = this.QUESTION_ENTITY.TEST;
          p1.entity_id = this.testDetails.id;
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.NEXT_QUESTION) {
        if (cq) {
          callApi = true;

          p1.activity = this.QUESTION_ACTIVITY.START;
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.entity_id = cq.id;
          p1.test_detail_id = cq.test_detail_id;
          p1.section_id = cq.section_id;
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.FINISH_TEST) {
        if (cq) {
          callApi = true;
          p1.activity = this.QUESTION_ACTIVITY.STOP;
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.entity_id = cq.id;
          p1.test_detail_id = cq.test_detail_id;
          p1.section_id = cq.section_id;
          p1.isAutoFinished = this.testAutoFinished;
          p1.answer = {
            status: cq.status,
            answer: this.getAnswerAsPerType(cq),
          };
          p1.end_action = this.QUESTION_ACTIONS.END_TEST;
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.CLEAR) {
        if (cq) {
          callApi = true;
          postData.push(_.cloneDeep(p1));
          postData.push(_.cloneDeep(p1));
          p2 = postData[1]; // start clear response
          let p3 = postData[2]; // stop clear respone
          let p4 = postData[3]; // start the same question again

          p1.activity = this.QUESTION_ACTIVITY.STOP; // stop the current question
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.test_detail_id = cq.test_detail_id;
          p1.entity_id = cq.id;
          p1.section_id = cq.section_id;
          p1.end_action = this.endAction;
          p1.answer = {
            status: cq.status,
            answer: this.getAnswerAsPerType(cq),
          };

          p2.activity = this.QUESTION_ACTIVITY.START;
          p2.entity = this.QUESTION_ENTITY.QUESTION;
          p2.index = 0;
          p2.test_detail_id = cq.test_detail_id;
          p2.entity_id = cq.id;
          p2.section_id = cq.section_id;
          p2.end_action = this.endAction;
          p2.answer = {
            status: cq.status,
            answer: null,
          };

          p3.activity = this.QUESTION_ACTIVITY.STOP;
          p3.entity = this.QUESTION_ENTITY.QUESTION;
          p3.index = 0;
          p3.test_detail_id = cq.test_detail_id;
          p3.entity_id = cq.id;
          p3.section_id = cq.section_id;
          p3.end_action = this.endAction;

          p4.activity = this.QUESTION_ACTIVITY.START;
          p4.entity = this.QUESTION_ENTITY.QUESTION;
          p4.index = 0;
          p4.entity_id = cq.id;
          p4.test_detail_id = cq.test_detail_id;
          p4.section_id = cq.section_id;
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.LAST_QUESTION) {
        if (cq) {
          callApi = true;

          p1.activity = this.QUESTION_ACTIVITY.START;
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.entity_id = cq.id;
          p1.test_detail_id = cq.test_detail_id;
          p1.section_id = cq.section_id;
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.FINISH_TEST_ERROR) {
        // if (cq) {
        callApi = true;
        p1.activity = this.QUESTION_ACTIVITY.STOP;
        p1.entity = this.QUESTION_ENTITY.QUESTION;
        p1.index = 0;
        p1.entity_id = cq ? cq.id : -1;
        p1.test_detail_id = cq ? cq.test_detail_id : -1;
        p1.section_id = cq ? cq.section_id : -1;
        p1.answer = {
          status: cq ? cq.status : -1,
          answer: this.finishTestError,
        };
        p1.end_action = this.QUESTION_ACTIONS.FINISH_TEST_ERROR;
        // }
      }

      if (callApi) this.updateProgress(postData);
    },

    updateProgress(data) {
      this.$root.showLoader = true;
      let postData = {
        test_institute_id: this.testDetails
          ? this.testDetails.test_institute_id
          : -1,
        test_schedule_id: this.testDetails
          ? this.testDetails.test_schedule_id
          : -1,
        actions: data,
      };

      this.updateProgressInDB(postData)
        .then((response) => {
          // console.log("updateProgressInDB: success");
          this.expansionPanelStatus = null;
          if (this.showNextQuestion) {
            this.nextQuestion();
          }
          if (this.endAction == this.QUESTION_ACTIONS.FINISH_TEST) {
            this.gotoSummary();
          }
          if (this.endAction == this.QUESTION_ACTIONS.CLEAR) {
            this.showTimer = true;
          }
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$toasted.error(
            "Error Updating status. Please check your internet connection and try again."
          );
          this.showTimer = true;
          this.$root.showLoader = false;
          this.isAnswerBtnClicked = false;
          if (err.data && err.data.errors) {
            err.data.errors.forEach((e) => {
              if (e.code == this.ERROR_CODES.TIMEOUTERROR) {
                this.setIsTestStarted(false);
                this.redirectAsType();
              }
            });
          }
        });
    },
    setCurrentQuestions() {
      this.isSQTChanged = false;
      this.questionData = this.subjectQuestionTypeList[this.selectedSQTIndex];
      this.questions = this.questionData.questions;
      setTimeout(async()=>await this.renderMath(),100);

      this.getChapters(this.questionData.subjectId,this.questionData.questions[0].sub_subject);
    },
   async nextQuestion() {
    
      let questionss = JSON.parse(localStorage.getItem("alternateQ"))
      if(questionss && questionss.id){
         await this.onAlternateButtonClick(this.currentQuestion);
      }
      localStorage.removeItem('alternateQ')
      this.expansionPanelStatus = null;

      // if subject question type is changed need to change the set of questions as selected type
      if (this.isSQTChanged) {
        this.setCurrentQuestions();
      }

      if (this.nextQuestionIndex == this.questions.length) {
        let nextSubjectQuestionTypeIndex = this.selectedSQTIndex + 1;
        if (
          nextSubjectQuestionTypeIndex < this.subjectQuestionTypeList.length
        ) {
          let nextType = this.subjectQuestionTypeList[
            nextSubjectQuestionTypeIndex
          ];

          this.setCurrentQuestionData(
            nextSubjectQuestionTypeIndex,
            nextType.currentQuestionIndex
          );
          this.nextQuestionIndex = nextType.currentQuestionIndex;
          this.setCurrentQuestions();
        } else {
          if (!this.isPreview) {
            this.endAction = this.QUESTION_ACTIONS.LAST_QUESTION;
            this.showNextQuestion = false;
            this.saveCurrentAction("nextQuestion");
          }
          this.isAnswerBtnClicked = false;
          this.showTimer = true;
          this.scrollToTop();
                setTimeout(async()=>await this.renderMath(),100);

          return;
        }
      }
      // else {
      let typeIndex = this.selectedSQTIndex;
      this.setSelectedQuestionIndex({
        currentQuestionIndex: this.nextQuestionIndex,
        typeIndex,
      });
      this.currentQuestion = this.questions[this.nextQuestionIndex];
	  

      this.$nextTick(() => {
        if (this.currentQuestion.status == this.questionStatus.INITIAL)
          this.currentQuestion.status = this.questionStatus.VISITED;
      });
      if (!this.isPreview) {
        this.showNextQuestion = false;
        this.endAction = this.QUESTION_ACTIONS.NEXT_QUESTION;
        this.saveCurrentAction("nextQuestion");
      }
      let storeCurrentQuestionCookie = {
        currentSQTIndex: this.selectedSQTIndex,
        currentQuestionIndex: this.nextQuestionIndex,
        userId: this.user.id,
        testId: this.$route.params.test_id,
        testInstituteId: this.$route.params.test_institute_id,
      };
      this.$cookies.set("CATAPULT_TEST", storeCurrentQuestionCookie);
      // }
      if (this.currentQuestion) {
        this.slectedChapter = {
          chapter_id: this.currentQuestion.chapterId,
          title: this.currentQuestion.chapterName,
        };
        this.getTopics(this.slectedChapter.chapter_id);
      }
      if (this.currentQuestion) {
        this.selectedTopic = {
          topic_id: this.currentQuestion.topic_id,
          title: this.currentQuestion.topicName,
        };
      }
      if (this.currentQuestion) {
        this.selectedDifficultyLevel = {
          id: this.currentQuestion.difficultyId,
          title: this.currentQuestion.difficultyName,
        };
      }
      this.scrollToTop();
      setTimeout(async()=>await this.renderMath(),100);
      this.renderMath();
      this.isAnswerBtnClicked = false;
      this.showTimer = true;

      if (this.scrollQtypeValue !== 1) {
        this.$refs.carousel.currentPage = this.$refs.carousel.scrollPerPage
          ? Math.round(
              this.$refs.carousel.offset /
                this.$refs.carousel.slideWidth /
                this.$refs.carousel.currentPerPage
            )
          : Math.round(
              this.$refs.carousel.offset / this.$refs.carousel.slideWidth
            );

        // this.$refs.carousel.goToPage(
        //     this.selectedSQTIndex + 1,
        //     "pagination"
        // );
        this.navigateTo = this.selectedSQTIndex;
      }
	  if(this.currentQuestion.question_bucket_count > 0 ){
	  	this.getQuestionBucket();
	  }
	  this.getQuestionDetails()

    },
    getAnswerAsPerType(q) {
      let answer = null;
      let selectedOption = null;
      let options = null;
      let questionType =
        q.question_type == this.questionTypes.COMPREHENSION ||
        q.question_type == this.questionTypes.TC
          ? q.subtype
          : q.question_type;

      if (
        questionType == this.questionTypes.TC_2Q_SA ||
        questionType == this.questionTypes.TC_3Q_SA ||
        questionType == this.questionTypes.COMPREHENSION_3Q_SA ||
        questionType == this.questionTypes.COMPREHENSION_2Q_MM ||
        questionType == this.questionTypes.COMPREHENSION_2Q_SA
      ) {
        questionType = this.questionTypes.SINGLE_CORRECT;
      } else if (
        questionType == this.questionTypes.COMPREHENSION_3Q_MA ||
        questionType == this.questionTypes.COMPREHENSION_2Q_MA
      ) {
        questionType = this.questionTypes.MULTIPLE_CORRECT;
      }
      switch (questionType) {
        case this.questionTypes.INTEGER:
          answer = q.correct_answer;
          break;

        case this.questionTypes.MATRIX_MATCH:
          options = [];
          q.options_abc.map((o, idx) => {
            if (o.correct_answer > "") {
              options.push({
                option_id: o.id,
                value: o.correct_answer,
              });
            }
          });
          answer = options.length > 0 ? options : null;
          break;

        case this.questionTypes.MATRIX_MATCH_OPTION:
          selectedOption = q.options.find(
            (option) => option.correct_answer == true
          );
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;

        case this.questionTypes.SUBJECTIVE:        
        case this.questionTypes.SUBJECTIVEINTEGER:
        case this.questionTypes.COMPREHENSION_2Q_NU:
          answer = {};
          answer = q.correct_answer;
          break;

        case this.questionTypes.ASSERTION_REASON:
          selectedOption = q.options.find(
            (option) => option.correct_answer == true
          );
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;

        case this.questionTypes.MULTIPLE_CORRECT:
          options = [];
          q.options.map((o, idx) => {
            if (o.correct_answer == true) {
              options.push(o.id);
            }
          });
          answer = options.length > 0 ? { option_id: options } : null;
          break;

        case this.questionTypes.SINGLE_CORRECT:
        case this.questionTypes.SINGLE_CORRECT_SEC2:
          selectedOption = q.options.find(
            (option) => option.correct_answer == true
          );
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;
      }
      return answer;
    },
    getAnswerForComprehension(q) {
      let answer = [];
      if (
        q.subtype == this.questionTypes.COMPREHENSION_2Q_SA ||
        q.subtype == this.questionTypes.COMPREHENSION_2Q_MM ||
        q.subtype == this.questionTypes.COMPREHENSION_3Q_SA ||
        q.subtype == this.questionTypes.TC_2Q_SA ||
        q.subtype == this.questionTypes.TC_3Q_SA
      ) {
        q.questions.map((ques, idx) => {
          let selectedOption = ques.options.find(
            (option) => option.correct_answer == true
          );
          if (selectedOption) {
            answer.push({
              question_id: ques.id,
              option_id: selectedOption.id,
            });
          }
        });
      } else {
        q.questions.map((ques, idx) => {
          let options = [];
          ques.options.map((o, idx) => {
            if (o.correct_answer == true) {
              options.push(o.id);
            }
          });

          if (options.length > 0) {
            answer.push({
              question_id: ques.id,
              option_id: options,
            });
          }
        });
      }
      return answer.length > 0 ? answer : null;
    },
    jumpToQuestion(palletData) { 
      this.bucketQuestions=[];
      this.showNextQuestion = true;
      this.showTimer = false;
      this.nextQuestionIndex = palletData.currentQuestionIndex;
      this.endAction = this.QUESTION_ACTIONS.JUMP;
      this.scrollQtypeValue = 2;
      this.saveCurrentAction("currentQuestion");
    
      // this.expansionPanelStatus = null;
    },
   async changeSubjectQuestionType(type, index, action) {
      let questionss = JSON.parse(localStorage.getItem("alternateQ"))
      if(questionss && questionss.id){
         await this.onAlternateButtonClick(this.currentQuestion);
      }
      this.bucketQuestions=[];
      localStorage.removeItem('alternateQ')
      this.showTimer = false;
      this.endAction = action ? action : this.endAction;
      this.showNextQuestion = true;
      this.isSQTChanged = true;
      this.setCurrentQuestionData(index, type.currentQuestionIndex);
      this.nextQuestionIndex = type.currentQuestionIndex;
      this.saveCurrentAction("currentQuestion");
      this.getChapters(type.subjectId,type.questions[0].sub_subject);
    },
    reverseQuestionsType() {
      Object.keys(this.questionTypes).forEach((qt) => {
        this.questionTypesReversed[this.questionTypes[qt]] = qt;
      });
    },
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const batchA = parseInt(a.index);
      const batchB = parseInt(b.index);

      let comparison = 0;
      if (batchA > batchB) {
        comparison = 1;
      } else if (batchA < batchB) {
        comparison = -1;
      }
      return comparison;
    },
    async separateQuestions() {
      let questions = this.questionsListStore;
      // questions.sort(this.compare);
      let fql = {}; // filteredQuestionsList
      let subjectQuestionTypeList = {}; // for showing subject - section list
      this.$root.showLoader = true;

      for (let i = 0; i < questions.length; i++) {
        let questionTypeId = 0;
        let questionTypeName = "";
        let q = null; // question
        let currentQuestionType = null; // current question in particular subject
        let subjectName = null; // current subject
        let subjectId = null; // current subject
        let subjectQuestionTypeObj = {};
        let questionId = 0;
        let subTypeName=0,subTypeId=""
        q = questions[i];
        questionId = q.id;
        questionTypeId = q.questiontype.id;
        questionTypeName = q.questiontype.value;
        subjectName = q.subject.title;
        subjectId = q.subject.id;
        subTypeName = q.subtype && q.subtype.value ? q.subtype.value :'' ;
        subTypeId =q.subtype && q.subtype.id ? q.subtype.id : '';
        if (q.sub_subject) {
          let subject = constants.BIOLOGY_SUBSUBJECTS.find(s=>s.code === q.sub_subject)
          if (subject) {
            subjectName = subject.title;
          } 
        }
        
        subjectQuestionTypeObj = {
          subjectName,
          questionTypeName,
          questionTypeId,
          subTypeId,
          subjectId,
          subTypeName,
        };

        let subjectQuestionTypeName = subjectName + questionTypeId + subTypeId||'' ;
        if (!subjectQuestionTypeList[subjectQuestionTypeName]) {
          subjectQuestionTypeList[subjectQuestionTypeName] = [];
          subjectQuestionTypeList[subjectQuestionTypeName].push(
            subjectQuestionTypeObj
          );
        }

        if (!fql[subjectName]) fql[subjectName] = {};
        let questionTypeIDName = subTypeId? subTypeId : questionTypeId

        if (!fql[subjectName][questionTypeIDName])
          fql[subjectName][questionTypeIDName] = {}; 
          currentQuestionType = fql[subjectName][questionTypeIDName];

        if (!currentQuestionType["questionIds"])
          currentQuestionType["questionIds"] = []; // list of questions
        currentQuestionType["questionIds"].push(questionId);
      }
      this.setTestData(fql); // in store
      await this.generateQuestionsList();
      this.generateSubjectQuestionList(subjectQuestionTypeList);
      let currentTestCookieExists = this.$cookies.isKey("CATAPULT_TEST");
      let questionIndex = 0;
      let sqtIndex = 0;
      if (currentTestCookieExists) {
        let currentTestDetails = this.$cookies.get("CATAPULT_TEST");
        if (
          currentTestDetails.testId == this.$route.params.test_id &&
          currentTestDetails.testInstituteId ==
            this.$route.params.test_institute_id &&
          currentTestDetails.userId == this.user.id
        ) {
          this.nextQuestionIndex = currentTestDetails.currentQuestionIndex;
          sqtIndex = currentTestDetails.currentSQTIndex;
        }
        let navigateTo = sqtIndex;
        if (isMobile()) {
          this.navigateTo = navigateTo;
        } else if (
          sqtIndex > 2 &&
          sqtIndex > this.subjectQuestionTypeList.length - 3 &&
          this.subjectQuestionTypeList.length > 2
        ) {
          navigateTo = sqtIndex - 2;
          this.navigateTo = navigateTo;
        }
      }
      this.setCurrentQuestionData(sqtIndex, 0);
    },
    setCurrentQuestionData(typeIndex, questionIndex) {
      this.setSelectedSQTIndex(typeIndex);
    },
    async generateQuestionsList() {
      let ql = this.questionsListStore;
      let currentQuestion = {};
      let questionsList = {};

      for (let i = 0; i < ql.length; i++) {
        const q = ql[i]; // current question in loop
        let questionTypeId = q.question_type;
        questionTypeId =
          questionTypeId == this.questionTypes.COMPREHENSION ||
          questionTypeId == this.questionTypes.TC
            ? q.subtype.id ?q.subtype.id :q.subtype
            : q.question_type;
        let currentQuestion = {};
        currentQuestion = this.generateQuestionObject(questionTypeId, q);
        currentQuestion.subtype = q.subtype ? q.subtype.id ?q.subtype.id :q.subtype:'';
        if (
          q.question_type == this.questionTypes.COMPREHENSION ||
          q.question_type == this.questionTypes.TC
        ) {
          currentQuestion.passage = q.passage;
        }
        currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
        questionsList[q.id] = currentQuestion;
      }
      this.setFilteredQuestionsList(questionsList);
    },
    getCurrentQuestionCommonKeys(currentQuestion, q) {
      currentQuestion.id = q.id;
      currentQuestion.questionNo = q.index;
      currentQuestion.question_text = q.question_text;
      currentQuestion.question_type = q.question_type;
      currentQuestion.questionType = { id: q.question_type };
      currentQuestion.parent_id = q.parent_id;
      currentQuestion.section_id = q.section_id;
      currentQuestion.test_detail_id = q.test_detail_id;
      currentQuestion.correct_marks = q.marks;
      currentQuestion.negative_marks = q.negative_marks;
      currentQuestion.partial_marking = q.partial_marking;
      currentQuestion.solution = q.solution;
      currentQuestion.hints = q.hints;
      currentQuestion.userSelectedAnswer = q.user_selected_answer;
      currentQuestion.status = this.questionStatus.INITIAL; // "status" along with "isAnswered" will be used for loading legends & pallet info
      currentQuestion.isAnswered = false; // to know if the current question is answered.
      currentQuestion.disabled = false; // disabled in case of preview test
      currentQuestion.isPreview = this.isPreview; // disabled in case of preview test
      currentQuestion.institute_id = q.question_institute_id;
      currentQuestion.sub_subject = q.sub_subject;
      currentQuestion.subType = q.subtype;
      if (this.isPreview) {
        currentQuestion.status = this.questionStatus.ANSWER_SELECTED_SAVED; // "status" along with "isAnswered" will be used for loading legends & pallet info
        currentQuestion.isAnswered = this.isPreview; // to know if the current question is answered.
        currentQuestion.disabled = this.isPreview; // disabled in case of preview test
      }
      if (q.user_selected_answer && !this.isPreview) {
        let answer = JSON.parse(q.user_selected_answer);
        currentQuestion.isAnswered = answer.answer ? true : false;
        currentQuestion.status = answer.status;
      }
	  if(this.user.role_id === this.roleIds.TR){
		  const index = this.teacherSubjectId.findIndex(t=>t===q.subject.id)
		  currentQuestion.isQuestionEditable = index>=0
	  }else{
		  currentQuestion.isQuestionEditable = true
		  
	  }
      return currentQuestion;
    },
    checkIfAnswered(type, q) {
      let option = null;
      if (q.user_selected_answer && !this.isPreview) {
        let answer = JSON.parse(q.user_selected_answer);
        q.status = answer.status;
        let options = q.options.map((o) => {
          return { ...o, ...{ correct_answer: false } };
        });
        if (answer.answer) {
          let switchType = 1;
          if (
            this.questionTypes.ASSERTION_REASON == type ||
            this.questionTypes.SINGLE_CORRECT == type ||
            this.questionTypes.SINGLE_CORRECT_SEC2 == type ||
            this.questionTypes.COMPREHENSION_2Q_SA == type ||
            this.questionTypes.COMPREHENSION_2Q_MM == type ||
            this.questionTypes.COMPREHENSION_3Q_SA == type ||
            this.questionTypes.TC_2Q_SA == type ||
            this.questionTypes.TC_3Q_SA == type
          ) {
            switchType = 1;
          } else {
            switchType = 2;
          }
          switch (switchType) {
            case 1:
              option = options.find((o) => o.id == answer.answer.option_id);
              if (option) option.correct_answer = true;
              break;

            case 2:
              answer.answer.option_id.map((a) => {
                option = options.find((o) => o.id == a);
                if (option) option.correct_answer = true;
              });
              break;
          }
        }
        return options;
      } else return q.options;
    },
    generateQuestionObject(typeId, q) {
      let type = "";
      type = this.getQuestionType(typeId);
      let currentQuestion = {};
      currentQuestion.chapterId = q.data_type_id;
      currentQuestion.chapterName = q.datatype ? q.datatype.title : "";
      currentQuestion.dataType = q.datatype;
      currentQuestion.datatype = q.datatype;
      currentQuestion.answer_type = q.answer_type;
      currentQuestion.difficulty = q.difficulty;
      if (q.difficulty_level) {
        currentQuestion.difficulty_level = q.difficulty_level || null;
        currentQuestion.difficultyName = this.difficulty.find(
          (d) => d.id === q.difficulty_level
        ).title;
        currentQuestion.difficultyId = this.difficulty.find(
          (d) => d.id === q.difficulty_level
        ).id;
      }
      currentQuestion.question_bucket_count = q.question_bucket_count;
      currentQuestion.time = q.time;
      currentQuestion.topic_id = q.topic_id;
      currentQuestion.topicName = q.topic ? q.topic.title : "";
      currentQuestion.topic = q.topic;
      currentQuestion.sub_subject = q.sub_subject;
      currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
      switch (type) {
        case 1:
          currentQuestion.options = this.checkIfAnswered(typeId, q);
          break;
        case 2:
          if (this.isPreview) {
            currentQuestion.correct_answer = q.correct_answer;
          } else if (q.user_selected_answer) {
            let answer = JSON.parse(q.user_selected_answer);
            currentQuestion.correct_answer = parseInt(answer.answer);
          } else {
            currentQuestion.correct_answer = null;
          }
          break;
        case 3:
          let matrixOptions = this.separateOptions(q, 1);
          currentQuestion.options_abc = matrixOptions.options_abc;
          currentQuestion.options_pqr = matrixOptions.options_pqr;
          break;
        case 4:
          let options = this.separateOptions(q, 2);
          currentQuestion.options_abc = options.options_abc;
          currentQuestion.options_pqr = options.options_pqr;
          currentQuestion.options = options.op;
          break;
        case 6:
          if (this.isPreview) {
            currentQuestion.correct_answer = q.correct_answer;
          } else if (q.user_selected_answer) {
            let answer = JSON.parse(q.user_selected_answer);
            currentQuestion.correct_answer = answer.answer;
          } else {
            currentQuestion.correct_answer = "";
          }
          let subjectiveAnswers = this.getSubjectiveAnswers(
            currentQuestion.correct_answer,
            q
          );
          currentQuestion.startValue = subjectiveAnswers.startValue;
          currentQuestion.endValue = subjectiveAnswers.endValue;
          break;
      }
      return currentQuestion;
    },
    getQuestionType(id) {
      if (
        id == this.questionTypes.ASSERTION_REASON ||
        id == this.questionTypes.MULTIPLE_CORRECT ||
        id == this.questionTypes.SINGLE_CORRECT ||
        id == this.questionTypes.COMPREHENSION_2Q_SA ||
        id == this.questionTypes.COMPREHENSION_2Q_MM ||
        id == this.questionTypes.COMPREHENSION_2Q_MA ||
        id == this.questionTypes.COMPREHENSION_3Q_SA ||
        id == this.questionTypes.COMPREHENSION_3Q_MA ||
        id == this.questionTypes.TC_2Q_SA ||
        id == this.questionTypes.TC_3Q_SA
      ) {
        return 1;
      } else if (id == this.questionTypes.INTEGER) {
        return 2;
      } else if (id == this.questionTypes.MATRIX_MATCH) {
        return 3;
      } else if (id == this.questionTypes.MATRIX_MATCH_OPTION) {
        return 4;
      } else if (id == this.questionTypes.COMPREHENSION) {
        return 5;
      } else if (id == this.questionTypes.SUBJECTIVE  || id == this.questionTypes.COMPREHENSION_2Q_NU  || id == this.questionTypes.SUBJECTIVEINTEGER) {
        return 6;
      }
    },
    getSubjectiveAnswers(answer, q) {
      let separatedAnswer = {
        startValue: null,
        endValue: null,
      };
      if (answer > "" && this.isPreview) {
        let answerArray = answer.split("##");
        if (answerArray.length == 2) {
          separatedAnswer.startValue = answerArray[0];
          separatedAnswer.endValue = answerArray[1];
        } else if (answerArray.length == 1) {
          separatedAnswer.startValue = answerArray[0];
        }
      } else if (q.user_selected_answer) {
        let answer = JSON.parse(q.user_selected_answer);
        if (
          answer.answer &&
          !answer.answer.startValue &&
          !answer.answer.endValue
        ) {
          separatedAnswer.correct_answer = parseInt(answer.answer);
        }
      }
      return separatedAnswer;
    },
    generateSubjectQuestionList(subjectQuestionTypeList) {
      let sqtl = []; // subjectQuestionTypeList
      let subjectQuestionTypeObj = {};
      let name = "";
      let shortName = "";
      let typeId = "";
      let subjectId = "";
      let subjectName = "";
      let questionIds = [];
      let typeList = [];
      let questions = [];
      let questionObj = {};
      let subjectNames = Object.keys(subjectQuestionTypeList);
      let subTypeId = "";
      subjectNames.forEach((subject) => {
        typeList = subjectQuestionTypeList[subject];
        questions = [];
        typeList.forEach((type) => {
          questionObj = {};
          name = type.subjectName + " - " +  (type.subTypeName?type.subTypeName:type.questionTypeName);
          shortName = type.subjectName
            ? type.subjectName.substr(0, 4) + " - " + (type.subTypeName?type.subTypeName:type.questionTypeName)
            : null;
          typeId = type.questionTypeId;
          subjectId = type.subjectId;
          subjectName = type.subjectName;          
          subTypeId = type.subTypeId;
          let typeIdName = subTypeId ? subTypeId: typeId;
          questionIds = this.testData[type.subjectName][typeIdName].questionIds;
          // questionIds.sort();
          questionIds.forEach((qi, idx) => {
            questionObj = this.filteredQuestionsList[qi];
            questionObj.currentQuestionIndex = idx + 1;
            questions.push(questionObj);
          });

          subjectQuestionTypeObj = {
            name,
            shortName,
            typeId,
            subjectId,
            questionIds,
            subjectName,
            questions,
			showSQT:this.teacherSubjectId.length ? this.teacherSubjectId.includes(subjectId):true,
            currentQuestionIndex: 0,
            showAnswerField: true, // will be changed to true when loading into question paper modal
          };
         if (subjectQuestionTypeObj.showSQT) {
	          sqtl.push(subjectQuestionTypeObj);
			}
        });
      });
      if (sqtl && sqtl.length > 0) {
        // this.getChapters(sqtl[0].subjectId);
      }

      this.setSubjectQuestionTypeList(sqtl);
      this.$root.showLoader = false;
      // this.subjectQuestionTypeList = sqtl;
    },
    onClose(data) {
      this.status = data.status;
      if (data.count) {
        this.currentQuestion.question_bucket_count = data.count;
      } else if (data.count === 0) {
        this.currentQuestion.question_bucket_count = 0;
      }
      //   if(data.reload){
      // 	  this.requestGetTestDetails();
      //   }
    },
    logOutUser() {
      this.$toasted.error(
        "You have a slow internet connection. Please check and try again."
      );
      this.$router.push({ name: "login" }).catch(() => {});
      this.logOut();
    },
    requestGetTestDetails() {
      let pendingTestList = this.pendingTestList;
      let reqData = {
        test_id: this.$route.params.test_id,
        test_institute_id: this.$route.params.test_institute_id,
        is_preview: this.isPreview,
      };
      if (!this.isPreview) {
        reqData.test_schedule_id = this.$route.params.test_schedule_id;
      }
      this.$root.showLoader = true;
      let fn = "getTestPreviewDetails";
      if (!this.isPreview) {
        fn = "getLiveTestDetails";
      }
      this[fn](reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.testDetails = response;
          this.duration = this.testDetails.timeRemaining;
          if (!this.isPreview) {
            this.startTimer(this.testDetails.timeRemaining);
            this.startHeartBeatTimer();
            this.getRemainingTimeInterval();
          }
          if (
            this.testDetails.test_type != this.TEST_TYPE.CUSTOM &&
            (this.$route.name == "preview-test" ||
              this.$route.name == "result-anaylysis-preview-test")
          ) {
            this.isTestCustom = false;
          }
          this.isEditable = this.testDetails.test_is_conducted_or_running === 1;
          this.instructions = response.instructions;
          this.separateQuestions();
          this.renderMath();
          // this.getQuestionData();
        })
        .catch((err) => {
          this.$root.showLoader = false;

        //   if (pendingTestList) {
        //     pendingTestList.shift();
        //     this.setPendingTestList(pendingTestList);
        //   }
        //   this.setIsTestStarted(false);
          // this.redirectAsType();
          this.$router.push({ name: "past-tests-teacher" });
        });
    },
    separateOptions(q, type) {
      let options = q.options;
      let op = [];
      let options_abc = [];
      let options_pqr = [];

      options.forEach((option) => {
        if (option.column == 1) {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : "";
          options_abc.push(option);
        } else if (option.column == 2) options_pqr.push(option);
        else {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : false;
          // option.correct_answer = false;
          op.push(option);
        }
      });
      if (type == 1) {
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            answer.answer.map((a) => {
              let option = options_abc.find((o) => o.id == a.option_id);
              if (option) {
                option.correct_answer = a.value;
              }
            });
          }
        }
      } else {
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            let option = op.find((o) => o.id == answer.answer.option_id);
            if (option) {
              option.correct_answer = true;
            }
          }
        }
      }

      return {
        op,
        options_abc,
        options_pqr,
      };
    },
    disableNavigation() {
      document.addEventListener("visibilitychange", this.checkVisiblity);
      // window.onfocus = this.checkPageStatus;
      // window.onblur = this.checkPageStatus;
      history.pushState(null, null, location.href);
      history.back();
      history.forward();
      window.onpopstate = function() {
        history.go(1);
      };

      window.onfocus = this.pageFocused;
      window.onblur = this.pageBlurred;
    },
    checkVisiblity() {
      if (document.visibilityState === "visible") {
        if (this.isBlurred) {
          this.isBlurred = false;
          this.getRemainingTime(false);
        }
        // this.isBlurred = false;
        // this.getRemainingTime();
      } else {
        if (this.timeRemainingInterval) {
          clearInterval(this.timeRemainingInterval);
          this.timeRemainingInterval = null;
        }
        this.isBlurred = true;
        this.hideTimer = true;
      }
    },
    pageBlurred() {
      if (this.timeRemainingInterval) {
        clearInterval(this.timeRemainingInterval);
        this.timeRemainingInterval = null;
      }
      this.isBlurred = true;
      this.hideTimer = true;
    },
    pageFocused() {
      if (this.$route.name === "test") {
        if (this.isBlurred) {
          this.isBlurred = false;
          this.getRemainingTime(false);
        }
      }
    },
    checkPageStatus() {
      /**
       * - below code is for getting remaining time when tabs are switched for more than 3 minutes
       * - remaining part handled in heartbeat method
       * */
      // this.pageInactive = true;
      // this.inactiveStartTime = moment();
    },
    getRemainingTime(isInterval) {
      let postData = {
        test_institute_id: this.testDetails.test_institute_id,
        test_detail_id: this.currentQuestion.test_detail_id,
        test_schedule_id: this.testDetails
          ? this.testDetails.test_schedule_id
          : -1,
      };
      // if (this.timeRemainingInterval) {
      //     clearInterval(this.timeRemainingInterval);
      // }
      this.remainingTime(postData)
        .then((res) => {
          // this.pageInactive = false;
          if (!isInterval) this.isBlurred = false;
          this.startTimer(res.remaining_time);
          // this.hideTimer = false;
        })
        .catch((err) => {
          if (err.data && err.data.errors) {
            err.data.errors.forEach((e) => {
              if (e.code == this.ERROR_CODES.TIMEOUTERROR) {
                this.setIsTestStarted(false);
                this.redirectAsType();
              }
            });
          } else {
            if (this.isOnline) {
              // this.$toasted.error("Error getting details.");
              location.reload();
            }
          }
        });
    },
    redirectAsType() {
      let route = "schedule-tests";
      switch (this.testDetails.test_type) {
        case this.TEST_TYPE.PREVIOUS_YEAR:
          route = "premium-test";
          break;
        case this.TEST_TYPE.CUSTOM:
          route = "schedule-tests";
          break;
      }
      this.removeCookie();
      this.$router.push({ name: route });
    },
    handleKeyboardEvents() {
      document.addEventListener("contextmenu", function(e) {
        e.preventDefault();
      });
      document.onkeydown = function(e) {
        if (event.keyCode == 123) {
          return false;
        }
        if (e.ctrlKey && e.keyCode == "R".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "R".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "I".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "C".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "J".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.keyCode == "U".charCodeAt(0)) {
          return false;
        }
      };
      // switch (event.keyCode) {
      //     case 116: // 'F5'
      //         event.preventDefault();
      //         event.returnValue = false;
      //         break;
      //     case 82: // 'F5'
      //         event.preventDefault();
      //         event.returnValue = false;
      //         event.keyCode = 0;
      //         window.status = "We have disabled F5";
      //         break;
      // }
    },
    getAnswerType(questionType, subtype) {
      let answerType = 0;

      if (
        questionType == this.QUE_TYPES.COMPREHENSION ||
        questionType == this.QUE_TYPES.TC
      ) {
        answerType = 0; // for questions with subtypes
        if (
          subtype == this.QUE_TYPES.TC_2Q_SA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_SA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_MM ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_MA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_NU
        ) {
          this.subQuestionLength = 2;
        } else if (
          subtype == this.QUE_TYPES.COMPREHENSION_3Q_MA ||
          subtype == this.QUE_TYPES.COMPREHENSION_3Q_SA ||
          subtype == this.QUE_TYPES.TC_3Q_SA
        ) {
          this.subQuestionLength = 3;
        }
      } else if (
        questionType == this.QUE_TYPES.ASSERTION_REASON ||
        questionType == this.QUE_TYPES.MULTIPLE_CORRECT ||
        questionType == this.QUE_TYPES.SINGLE_CORRECT
      ) {
        answerType = 1; // for questions options
      } else if (
        questionType == this.QUE_TYPES.MATRIX_MATCH_OPTION ||
        questionType == this.QUE_TYPES.MATRIX_MATCH
      ) {
        answerType = 2; // for questions with options, optionsabc, optionspqr
      } else if (questionType == this.QUE_TYPES.SUBJECTIVE || questionType == this.QUE_TYPES.SUBJECTIVEINTEGER) {
        answerType = 3; // for subjective type questions
      } else if (questionType == this.QUE_TYPES.INTEGER) {
        answerType = 4; // for integer type questions
      }
      return answerType;
    },
    validate() {
      let isValid = true;
      if (!this.slectedChapter.chapter_id) {
        this.$toasted.error("Please Select Chapter");
        isValid = false;
      }
      if (!this.selectedTopic.topic_id) {
        this.$toasted.error("Please Select Topic");
        isValid = false;
      }
      if (!this.selectedDifficultyLevel.id) {
        this.$toasted.error("Please Select Difficulty Level");
        isValid = false;
      }
      return isValid;
    },
    // questionBucketPopup() {
    //   this.alertBoxData = {
    //     question: {
    //       ...this.currentQuestion,
    //       target_exam: this.testDetails.target,
    //     },
    //     errorDescription: "",
    //     isPreview: this.isPreview,
    //   };
    //   this.modalWidth = "1000px";
    //   this.status = true;
    //   this.cComponent =
    //     "components/coordinator/Tests/CustomizedTests/QuestionBucket";
    //   this.$forceUpdate();
    // },
	getTeacherSubjectTree(){
		this.getTeacherSubject()
			.then(response=>{
				this.teacherSubjectId = response;
			})
			.catch(err=>{
				this.$toasted.error("Error finding teachers subjects.")
			})
	},
	onAlternateButtonClick(question){
		let currentQuestion = JSON.parse(localStorage.getItem('alternateQ'));
		if(!currentQuestion){
			localStorage.setItem('alternateQ',JSON.stringify(this.currentQuestion))
		}
		if(this.currentQuestion.id === question.id && this.currentQuestion.btnClicked) {
			let j = this.bucketQuestions.findIndex(q=>q.id===question.id)

			// let index = this.questions.findIndex(b=>b.id===question.id)
			if(j>=0){
				this.bucketQuestions[j].btnClicked = false;
			}
			let questions = JSON.parse(localStorage.getItem('alternateQ'));
			localStorage.removeItem('alternateQ')
			this.updateSearchAnotherQuestion(this.currentQuestion,questions)
		} else {
			this.bucketQuestions.map(q=>q.btnClicked=false)
			let index = this.bucketQuestions.findIndex(q=>q.id===question.id)
			if(index>=0){
				this.bucketQuestions[index].btnClicked = true
			}
			this.updateSearchAnotherQuestion(this.currentQuestion,this.bucketQuestions[index])
		}
	},
	setHeight(e){
		let height = this.getHeight(this.$refs.testView);
        var elem = document.getElementsByClassName("que-scrollable-area");
		if(elem.length){
			elem[0].style.height = parseInt(height)/2 + 'px';
		}
    var elem1 = document.getElementsByClassName("number-contet");
		if(elem1.length){
			elem1[0].style.height = parseInt(height)/2 + 'px';
		}
    var elem2 = document.getElementsByClassName("bar-chart-row");
		if(elem2.length){
			elem2[0].style.height = parseInt(height)/2 - 107 + 'px';
		}
    var elem3 = document.getElementsByClassName("PieChart-cp3-block");
		if(elem3.length){
			elem3[0].style.height = parseInt(height)/2 - 107 + 'px';
		}
    var elem4 = document.getElementsByClassName("resize-triggers");
		if(elem4.length){
			elem4[0].style.height = parseInt(height)/2 + 'px';
		}
	}
  },
};
</script>
